import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';


import { MatIconModule } from '@angular/material/icon';
import { IconColor } from './types/icon-color.types';
import { TranslationService } from '../../../core/services/translate.service';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'epmax-icon',
    imports: [MatIconModule, CommonModule],
    templateUrl: './icon.component.html',
    styleUrls: ['./../typo/typo.component.scss', './icon.component.scss']
})
export class IconComponent implements OnChanges{
  listOfIconsToBeRotated = ['arrow_forward','arrow_right_alt','arrow_left','keyboard_arrow_right','keyboard_arrow_left','chevron_right','chevron_left','arrow_back_ios_new',]
  iconsToBeFlipped = ['send']
  @Input() isPointer : boolean = false
  @Input() roundedBg : 'full' | 'half' | null = null
  @Input() isOutlined: boolean = false;
  @Input() name: string = 'home';
  @Input() color: IconColor | string = 'primary';
  @Input() customClass: string = '';
  @Input() size: number = 24;
    @Input() opticalSize: number = 24;
    @Input() disabled: boolean = false;
  @Input() weight: 100 | 200 | 300 | 400 | 500 | 600 | 700 | number = 400;
  @Input("grade") _grade: "low" | "high" | "default" | string = "default";
  className!: string; 
  @Input({ alias: 'data-automation-id' }) dataAutomationId !: string;
  
  constructor(private translate: TranslationService) { }
    ngOnChanges(): void {
        this.className = `${this.colorClass} ${this.rotate} ${this.flip}`.trim();
    }
  public get fontVariationSettings(): string {
    return `"FILL" ${+!this.isOutlined}, "wght" ${this.weight}, "GRAD" ${this.grade}, "opsz" ${this.opticalSize}`;
    }

    public get resolvedColor(): string | null {
        return this.isCssColor(this.color) ? this.color : null;
    }

    public get colorClass(): string {
        return this.isCssColor(this.color) ? '' : `icon-${this.color}`;
    }


  public get grade(): number {
    switch (this._grade) {
      case "low":
        return -25;
      case "high":
        return 200;
      default:
        return 0;
    }
  }

  public get rotate(): string {
    if ((this.listOfIconsToBeRotated.includes(this.name) && this.translate.currentLang == "en")) {
      return 'rotate';

    }
    return '';
  }
  get flip(): string {
    if (this.iconsToBeFlipped.includes(this.name)) {
      return 'rotate180Deg';
    }
    return '';
    }

    private isCssColor(value: string): boolean {
        if (!value) return false;

        return (
            value.startsWith('#') ||
            value.startsWith('rgb') ||
            value.startsWith('hsl') ||
            value.startsWith('var(')
        );
    }


}
